// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".filters-wrapper[data-v-dddfafea]{background-color:#fff;padding:15px 30px 31px;width:100%}.top-indent-12[data-v-dddfafea]{margin-top:12px}.top-indent-6[data-v-dddfafea]{margin-top:6px}.reset-button[data-v-dddfafea]{font-size:12px;font-weight:300}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
